export enum StoreId {
    ITUNES = 1,
    GOOGLEPLAY,
    AMAZON,
    WILDTANGENT,
    THREESIXTY,
    FACEBOOK,
    SAMSUNG,
    FACEBOOK_ARCADE,
    WEB
}